<!--
 * @Author: “zhaoh” “zhaohang0805@qq.com”
 * @Date: 2020-05-24 21:56:40
 * @LastEditors: “zhaoh” “zhaohang0805@qq.com”
 * @LastEditTime: 2024-01-17 16:56:40
 * @FilePath: \cshf\src\pages\aboutUsList\aboutus.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="font20 col333 font600 textcenter line50 borderb">走进四川百成恒泰</div>
    <div><p class="font14 col666 line28 padtb10" style="color:#666">四川百成恒泰房地产营销策划有限公司是一家企业服务平台（自开发找房软件城市好房），平台满足：写字楼租售，一手楼盘，在线找房，房源发布，资源管理。我们以客户为中心。我们秉承诚信，专业，高效的服务理念，始终关注客户的需求与市场变化。不断精进个升级我们的产品和服务。我们相信，只有真正了解客户需求，解决客户需求，才能赢得更多的信任与支持。
<br>联系地址：四川省成都市锦江区东大街芷泉段229号1栋2单元6层608号</p></div>
    <div><img src="/static/img/banner.png" class="wid100" alt=""></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style  lang="scss">
.wid100{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/aboutUsList/aboutus.vue